/**
 * Point CA ↔ US switcher links at the matching hreflang URL.
 *
 * Translate & Adapt changes handles (/pages/store → /fr/pages/magasins).
 * The switcher used to strip /fr and keep the French handle, which 404s on US.
 * The hreflang-tags app already emits the correct alternate (en-us / en-ca).
 */
(() => {
  const ATTR = 'data-fv-hreflang';

  const alternateHref = (hreflang) => {
    const wanted = String(hreflang || '').toLowerCase();
    if (!wanted) return null;

    for (const link of document.querySelectorAll('link[rel="alternate"][hreflang]')) {
      const value = (link.getAttribute('hreflang') || '').toLowerCase();
      if (value === wanted && link.href) return link.href;
    }

    return null;
  };

  /**
   * Swap in the alternate URL while keeping any params the theme rendered onto the
   * original (notably Orbe's ?oc=, which hands the country choice off on landing).
   * Params already on the alternate win.
   */
  const withRenderedParams = (href, original) => {
    if (!original) return href;

    try {
      const merged = new URL(href);
      for (const [key, value] of new URL(original, window.location.href).searchParams) {
        if (!merged.searchParams.has(key)) merged.searchParams.set(key, value);
      }
      return merged.toString();
    } catch (e) {
      return href;
    }
  };

  const apply = () => {
    document.querySelectorAll(`[${ATTR}]`).forEach((el) => {
      const href = alternateHref(el.getAttribute(ATTR));
      if (!href) return;

      if (el instanceof HTMLAnchorElement) {
        el.href = withRenderedParams(href, el.getAttribute('href'));
      } else if (el instanceof HTMLOptionElement) {
        el.setAttribute('data-store-url', withRenderedParams(href, el.getAttribute('data-store-url')));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
